import { UserRole } from '@/types'

/**
 * Maps each admin route to the roles allowed to access it.
 * Routes not listed here are accessible to all admin roles.
 * The backend enforces write-level permissions independently;
 * this is purely for frontend UX (hiding sections the user can't act on).
 */

type RoleConfig = Record<string, UserRole[]>

const ALL_ADMIN: UserRole[] = ['super_admin', 'admin', 'finance', 'support']

export const ROUTE_ROLES: RoleConfig = {
  '/': ALL_ADMIN,
  '/users': ALL_ADMIN,
  '/beta-requests': ['super_admin', 'admin', 'support'],
  '/feedback': ['super_admin', 'admin', 'support'],
  '/client-config': ['super_admin', 'admin', 'support'],
  '/plans': ['super_admin', 'admin'],
  '/organizations': ['super_admin', 'admin'],
  '/packages': ['super_admin', 'admin'],
  '/coupons': ['super_admin', 'admin'],
  '/credit-costs': ['super_admin', 'admin'],
  '/boosts': ['super_admin', 'admin'],
  '/addons': ['super_admin', 'admin'],
  '/knowledge-bases': ['super_admin', 'admin'],
  '/distribution-modes': ['super_admin', 'admin'],
  '/templates': ['super_admin', 'admin'],
  '/email-templates': ['super_admin', 'admin'],
  '/email-campaigns': ['super_admin', 'admin'],
  '/landing-pages': ['super_admin', 'admin'],
  '/revenue': ['super_admin', 'admin', 'finance'],
  '/rapidapi': ['super_admin'],
  '/analytics': ALL_ADMIN,
  '/settings': ['super_admin', 'admin'],
  '/audit': ALL_ADMIN,
}

export function canAccessRoute(role: UserRole | undefined, route: string): boolean {
  if (!role) return false
  const allowed = ROUTE_ROLES[route]
  if (!allowed) return true // routes without explicit config are open to all admins
  return allowed.includes(role)
}
